// import React from "react";
// import mail from "../Assets/subscribe.svg";
// import "./Newsletter.css"; // Make sure to create this CSS file
// import {
//   FaFacebookF,
//   FaTwitter,
//   FaPinterestP,
//   FaInstagram,
// } from "react-icons/fa";

// const Newsletter = () => {
//   return (
//     <div className="newsletter">
//       <div className="newsletter-container">
//         {/* Left Section - Text */}
//         <div className="newsletter-text">
//           <div className="newsletter-container-new">
//             <img src={mail} alt="mail" className="mail" />
//           </div>
//           <div className="text">
//             <h2>Subscribe our Newsletter</h2>
//             <p>Pellentesque eu nibh eget mauris congue mattis matti.</p>
//           </div>
//         </div>

//         {/* Middle Section - Input Field */}
//         <div className="newsletter-input">
//           <input type="email" placeholder="Your email address" />
//           <button className="subscribe-btn">Subscribe</button>
//         </div>

//         {/* Right Section - Social Icons */}
//         <div className="newsletter-social">
//   <a 
//     href="https://www.facebook.com/" 
//     target="_blank" 
//     rel="noopener noreferrer"
//   >
//     <FaFacebookF />
//   </a>
//   <a 
//     href="https://x.com/?lang=en" 
//     target="_blank" 
//     rel="noopener noreferrer"
//   >
//     <FaTwitter />
//   </a>
//   <a 
//     href="https://in.pinterest.com/" 
//     target="_blank" 
//     rel="noopener noreferrer"
//   >
//     <FaPinterestP />
//   </a>
//   <a 
//     href="https://www.instagram.com/accounts/login/?hl=en" 
//     target="_blank" 
//     rel="noopener noreferrer"
//   >
//     <FaInstagram />
//   </a>
// </div>

//       </div>
//     </div>
//   );
// };

// export default Newsletter;

import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import mail from "../Assets/subscribe.svg";
import { postWithoutTokenAPI, getWithTokenAPI } from "../../util/Api";
import "./Newsletter.css";
// import {
//   FaFacebookF,
//   FaTwitter,
//   FaTiktok,
//   FaPinterestP,
//   FaInstagram,
// } from "react-icons/fa";
// import { IoLogoYoutube } from "react-icons/io";
// import { FaXTwitter } from "react-icons/fa6";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic email validation
    if (!email || !email.includes("@")) {
      toast.error("Please enter a valid email address.", {
        position: "top-right",
      });
      return;
    }

    setIsLoading(true);

    try {
      const response = await postWithoutTokenAPI("/newsletter/create", {
        email: email,
      });

      if (response.statusCode === 200) {
        toast.success("Thank you for subscribing to our newsletter!", {
          position: "top-right",
        });
        setEmail(""); // Clear the input field
      } else {
        toast.error(
          response.message || "Subscription failed. Please try again.",
          {
            position: "top-right",
          }
        );
      }
    } catch (error) {
      console.error("Subscription error:", error);
      toast.error("Failed to subscribe. Please try again later.", {
        position: "top-right",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="newsletter">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <div className="newsletter-container">
        {/* Left Section - Text */}
        <div className="newsletter-text">
          <div className="newsletter-container-new">
            <img src={mail} alt="mail" className="mail" />
          </div>
          <div className="text">
            <h2>Subscribe to our Newsletter</h2>
            {/* <p>Pellentesque eu nibh eget mauris congue mattis matti.</p> */}
          </div>
        </div>

        {/* Middle Section - Input Field */}
        <div className="newsletter-input">
          <input
            type="email"
            placeholder="Your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button
            className="subscribe-btn"
            onClick={handleSubmit}
            disabled={isLoading}
          >
            {isLoading ? "Subscribing..." : "Subscribe"}
          </button>
        </div>

        {/* Right Section - Social Icons */}
        {/* <div className="newsletter-social">
          <a
            href="https://www.instagram.com/shamba_sync/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram />
          </a>
          <a
            href="https://web.facebook.com/profile.php?id=61576904680253"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebookF />
          </a>
          <a
            href="https://www.youtube.com/@Shambasynckenya"
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoYoutube />
          </a>
           <a
            href="https://x.com/shambasync"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaXTwitter />
          </a>
          <a
            href="https://www.tiktok.com/@shambasync"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTiktok />
          </a>
        </div> */}
      </div>
    </div>
  );
};

export default Newsletter;
